export default __webpack_public_path__ + "static/media/logo-bsc.90fc0ea2.svg";